import React, { useEffect } from "react";
import { login } from "../auth/auth";
import { userManager } from "../auth/oidc";
import logoUrl from "../resources/images/schick-logo-white.png";
import "./login.css";

export default function LoginPage() {
  useEffect(() => {
    (async () => {
      const user = await userManager.getUser();
      if (user && !user.expired) window.location.replace("/");
    })();
  }, []);

   return (
    <div className="login-shell">
      <div className="login-card">
        <span className="login-logo"><img src={logoUrl} alt="Schick" /></span>
        <h1 className="login-title">Schick Admin</h1>
        <p className="login-text">Melde dich an, um Events, Freigaben und Veranstalter zu verwalten.</p>
        <button className="login-button" onClick={login}>Anmelden</button>
        <p className="login-footer">Sichere Anmeldung über Keycloak</p>
      </div>
    </div>
  );
}
